import React from 'react';

import Typography from '@mui/material/Typography';

import { IncludeExcludeLayout } from 'widgets-v6/layout';
import { GroupedMultiSelect } from 'widgets-v6/select';

import {
    getDoohPublisherNamesFromIds,
    getDoohPublishersOptions,
} from 'states/resources/ads/business-logic';

export const TargetDoohPublishers = ({
    onFieldChange,
    errors,
    doohPublishers,
    target_dooh_publishers,
    target_dooh_publishers_exclude,
    classes,
}) => {
    const doohPublisherOptions = getDoohPublishersOptions(doohPublishers);
    return (
        <>
            <IncludeExcludeLayout type="Include" marginBottom>
                <GroupedMultiSelect
                    value={target_dooh_publishers}
                    clearable={true}
                    placeholder={
                        target_dooh_publishers?.length > 0
                            ? ''
                            : 'Select DOOH Publishers to Include'
                    }
                    options={doohPublisherOptions}
                    onChange={values => onFieldChange('target_dooh_publishers')(values)}
                />
            </IncludeExcludeLayout>
            <IncludeExcludeLayout type="Exclude">
                <GroupedMultiSelect
                    value={target_dooh_publishers_exclude}
                    clearable={true}
                    placeholder={
                        target_dooh_publishers_exclude?.length > 0
                            ? ''
                            : 'Select DOOH Publishers to Exclude'
                    }
                    options={doohPublisherOptions}
                    onChange={values => onFieldChange('target_dooh_publishers_exclude')(values)}
                />
            </IncludeExcludeLayout>
            {errors?.target_dooh_publishers && classes?.appListError && (
                <Typography
                    classes={{
                        root: classes.appListError,
                    }}
                >
                    {errors.target_dooh_publishers}
                </Typography>
            )}
        </>
    );
};

export const DoohPublishersSummary = ({
    target_dooh_publishers,
    target_dooh_publishers_exclude,
    doohPublishers,
}) => {
    return (
        <React.Fragment>
            <IncludeExcludeLayout type="Include" marginBottom>
                {target_dooh_publishers.length > 0
                    ? getDoohPublisherNamesFromIds(target_dooh_publishers, doohPublishers).join(
                          ', '
                      )
                    : 'All Publishers'}
            </IncludeExcludeLayout>
            <IncludeExcludeLayout type="Exclude">
                {target_dooh_publishers_exclude.length > 0
                    ? getDoohPublisherNamesFromIds(
                          target_dooh_publishers_exclude,
                          doohPublishers
                      ).join(', ')
                    : 'None'}
            </IncludeExcludeLayout>
        </React.Fragment>
    );
};
